// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class ClubsAPI extends MainAPI {
	/**
	* @return {object} admin tab reported table list
	* @param {*} reportedDetails
	**/
	async getAdminReported(breedId, reportedDetails) {
		return API.get(`${ENDPOINTS.GET_ADMIN_REPORTED}/${breedId}?${queryString.stringify(reportedDetails)}`);
	}

	/**
	* @param {*} reportedDetails // report details
	**/
	async report(reportedDetails) {
		return API.post(ENDPOINTS.POST_REPORT, reportedDetails);
	}

	/**
	* @param {Number} breedId
	* @param {Number} reportId
	* @param {String} type - Can be approve or disapprove
	**/
	async putActionReportedContent(groupId, reqBody) {
		return API.put(`${ENDPOINTS.PUT_REPORT_CONTENT}/${groupId}/update-report-status`,reqBody);
	}

	async clubCreateGroup(reqBody) {
		return API.post(`${ENDPOINTS.POST_GROUP}`, reqBody);
	}

	/**
	* @param {Number} 
	**/
	async getGroups(groupDetails) {
		return API.get(`${ENDPOINTS.GET_GROUP}?${queryString.stringify(groupDetails)}`);
	}

	/**
	* @param {Number} groupId
	* @param {Object} memberDetails
	**/
	async getGroupMembers(groupId, memberDetails) {
		return API.get(`${ENDPOINTS.GET_GROUP}/${groupId}/member?${queryString.stringify(memberDetails)}`);
	}

	/**
	* @param {Number} groupId
	* @param {Array} customerIds
	**/
	async addMemberToGroup(groupId, reqBody) {
		return API.post(`${ENDPOINTS.POST_GROUP}/${groupId}/member`, reqBody);
	}

	/**
	* @param {Number} groupId
	**/
	async requestToJoinInGroup(groupId) {
		return API.post(`${ENDPOINTS.POST_GROUP}/${groupId}/requestToJoin`);
	}

	/**
	* @param {Number} groupId
	* @param {Array} customerIds
	**/
	async updateGroupMemberStatus(groupId, reqBody) {
		return API.put(`${ENDPOINTS.PUT_GROUP}/${groupId}/update-member-status`, reqBody);
	}

	/**
	* @param {Number} groupId
	* @param {Array} customerIds
	**/
	async updateGroupMemberAccess(groupId, reqBody) {
		return API.put(`${ENDPOINTS.PUT_GROUP}/${groupId}/update-member-access`, reqBody);
	}

	/**
	* @param {Object} requesBbody
	**/
	async getAllGroupMembers(reqBody) {
		return API.get(`${ENDPOINTS.GET_GROUP}/member`, reqBody);
	}

	async getGroupAdminRequest() {
		return API.get(`${ENDPOINTS.GET_GROUP}/admin/requests`);
	}
}

export default new ClubsAPI();